import {useMemo} from 'react'

import type {MemexItemModel} from '../../models/memex-item-model'
import {usePaginatedMemexItemsQuery} from './queries/use-paginated-memex-items-query'

type MemexItemsHookReturnType = {
  /**
   * List of all memex item models loaded for the current view.
   */
  items: Readonly<Array<MemexItemModel>>
}

export const useMemexItems = (): MemexItemsHookReturnType => {
  const {data} = usePaginatedMemexItemsQuery()
  return useMemo(() => {
    return {items: data.flatMap(q => q.nodes)}
  }, [data])
}
